import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { FaUserEdit, FaUser, FaUsers } from "react-icons/fa";
import debounce from "lodash.debounce";
import { useGetWorkbooksMutation } from "./EditDataSourceSlice";
import { useGetAllGroupsQuery } from "../Group/groupApislice";
import { useGetUsersQuery } from "../Admin/adminApiSlice";
import { useAssignWorkbookAccessMutation } from "./EditDataSourceSlice";
import { useAssignWorkbookpermissionMutation } from "./EditDataSourceSlice";

const Accessworkbookpage = ({ onValueChange }) => {
  const [userPermissions, setUserPermissions] = useState({});
  const [selectedPermission, setSelectedPermission] = useState("edit");
  const [selectedItems, setSelectedItems] = useState([]);
  const [groupPermissions, setGroupPermissions] = useState({});
  const [isUpdateSuccesss, setIsUpdateSuccesss] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchParams] = useSearchParams();
  const [selectAll, setSelectAll] = useState(false);

  const debouncedAssignPermission = useRef(
    debounce((params) => {
      assignWorkbookpermission(params);
    }, 800)
  ).current;

  const [assignWorkbookpermission, { isLoading, isSuccess, isError, error }] =
    useAssignWorkbookpermissionMutation();

  const [
    assignWorkbookAccess,
    {
      isLoading: isUpdating,
      isError: isUpdateError,
      isSuccess: isUpdateSuccess,
    },
  ] = useAssignWorkbookAccessMutation();

  const {
    data: groups = [],
    isLoading: isGroupsLoading,
    isError: isGroupsError,
  } = useGetAllGroupsQuery();

  // console.log(groups);

  const {
    data: users = [],
    isLoading: isUsersLoading,
    isError: isUsersError,
  } = useGetUsersQuery();

  // console.log(users);

  const filteredGroups = groups.filter((group) =>
    group.groupName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredUsers = users.filter((user) =>
    user.username.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCheckboxChange = (id) => {
    // console.log("Checkbox ID:", id);
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSelectAllChange = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setSelectedItems(
      newSelectAll ? allFilteredItems.map((item) => item.id) : []
    );
  };

  const allFilteredItems = [
    ...filteredUsers.map((user) => ({
      id: user.username,
      label: user.username,
      type: "user",
      realId: user._id,
    })),
    ...filteredGroups.map((group) => ({
      id: group.groupName,
      label: group.groupName,
      type: "group",
      realId: group._id,
    })),
  ];

  const handleGroupSliderChange = (groupName, event) => {
    const newPermissionValue = Number(event.target.value);
    setGroupPermissions((prevPermissions) => ({
      ...prevPermissions,
      [groupName]: newPermissionValue,
    }));
    // const newPermission =
    //   newPermissionValue === 3
    //     ? "publish"
    //     : newPermissionValue === 2
    //     ? "edit"
    //     : newPermissionValue === 1
    //     ? "read"
    //     : "no access";

    const newPermission =
      newPermissionValue === 2
        ? "edit"
        : newPermissionValue === 1
        ? "read"
        : "no access";

    if (onValueChange) {
      onValueChange(groupName, newPermission);
    }
    // Trigger API call with groupId
    debouncedAssignPermission({
      workbookId: savedWorkBookId,
      template: newPermission,
      groupId: groupName,
    });
  };

  const handleUserSliderChange = (username, event) => {
    const newValue = Number(event.target.value);
    setUserPermissions((prev) => ({
      ...prev,
      [username]: newValue,
    }));

    // const newPermission =
    //   newValue === 3
    //     ? "publish"
    //     : newValue === 2
    //     ? "edit"
    //     : newValue === 1
    //     ? "read"
    //     : "no access";

    const newPermission =
      newValue === 2 ? "edit" : newValue === 1 ? "read" : "no access";

    if (onValueChange) {
      onValueChange(username, newPermission);
    }
    debouncedAssignPermission({
      workbookId: savedWorkBookId,
      template: newPermission,
      userId: username,
    });
  };

  const savedWorkBookId =
    searchParams.get("workbookid") || sessionStorage.getItem("workBookId");

  const [
    getWorkbooks,
    {
      data: accessWorkbook = {},
      isLoading: isAccessLoading,
      isError: isAccessError,
    },
  ] = useGetWorkbooksMutation();

  useEffect(() => {
    if (savedWorkBookId) {
      getWorkbooks(savedWorkBookId);
    }
  }, [savedWorkBookId]);

  useEffect(() => {
    const accessArray = accessWorkbook?.access || [];

    const initialUserPermissions = {};
    const initialGroupPermissions = {};

    accessArray.forEach((access) => {
      access.allowedUsers?.forEach((user) => {
        initialUserPermissions[user] =
          // access.permission === "publish"
          //   ? 3
          //   : access.permission === "edit"
          //   ? 2
          //   : access.permission === "read"
          //   ? 1
          //   : access.permission === "no access"
          //   ? 0
          //   : 0;
          access.permission === "edit"
            ? 2
            : access.permission === "read"
            ? 1
            : access.permission === "no access"
            ? 0
            : 0;
      });

      access.allowedGroups?.forEach((group) => {
        initialGroupPermissions[group] =
          // access.permission === "publish"
          //   ? 3
          //   : access.permission === "edit"
          //   ? 2
          //   : access.permission === "read"
          //   ? 1
          //   : access.permission === "no access"
          //   ? 0
          //   : 0;
          access.permission === "edit"
            ? 2
            : access.permission === "read"
            ? 1
            : access.permission === "no access"
            ? 0
            : 0;
      });
    });

    setUserPermissions(initialUserPermissions);
    setGroupPermissions(initialGroupPermissions);
  }, [accessWorkbook]);

  const handleSave = async () => {
    const userList = [];
    const groupList = [];

    selectedItems.forEach((itemId) => {
      const item = allFilteredItems.find((i) => i.id === itemId);
      if (item) {
        if (item.type === "user") {
          userList.push({ id: item.id });
        } else if (item.type === "group") {
          groupList.push({ id: item.id });
        }
      }
    });

    const payload = {
      type: "user", // You can change this dynamically if needed
      template: selectedPermission,
      workbookId: savedWorkBookId,
      userList,
      groupList,
    };

    try {
      const response = await assignWorkbookAccess(payload).unwrap();
      // console.log("Update Response:", response);
      setIsUpdateSuccesss(true);
      setTimeout(() => {
        setShowModal(false);
      }, 1000);
      getWorkbooks(savedWorkBookId);
    } catch (error) {
      console.error("Error updating database access:", error);
    }
  };

  const accessArray = accessWorkbook?.access || [];

  return (
    <div className="p-6 bg-white rounded-xl border-gray-200">
      <div className="w-full max-h-[700px] overflow-auto border rounded-md">
        <div className="flex items-start gap-4 p-4 bg-white shadow-sm rounded-xl mb-6">
          <FaUserEdit className="w-6 h-6 text-blue-950 mt-1" />
          <div>
            <h2 className="text-lg font-semibold text-gray-800">
              User/Group Permissions
            </h2>
            <p className="text-sm text-gray-600">
              Configure and control access levels for users and groups within
              the console to ensure secure and efficient collaboration.
            </p>
          </div>
        </div>
        <table className="w-full border-collapse">
          <thead className="sticky top-0 z-10 bg-gray-100">
            <tr className="text-sm text-gray-700 border-b border-gray-300">
              <th className="text-center px-10 py-3 border-r border-gray-300 w-1/3">
                Group/User
              </th>
              <th className="text-center px-10 py-3 border-r border-gray-300 w-1/6">
                No Access
              </th>
              <th className="text-center px-10 py-3 border-r border-gray-300 w-1/6">
                Read
              </th>
              <th className="text-center px-10 py-3 border-r border-gray-300 w-1/6">
                Edit
              </th>
              {/* <th className="text-center px-10 py-3 border-r border-gray-300 w-1/6">
                Publish
              </th> */}
            </tr>
          </thead>
          <tbody>
            {accessArray.map((entry, index) => (
              <React.Fragment key={index}>
                {entry.allowedUsers?.map((userName, i) => (
                  <tr
                    key={`user-${userName}-${i}`}
                    className="border-b border-gray-200 hover:bg-gray-50 text-sm"
                  >
                    <td className=" px-10 py-2">
                      <div className="flex items-center gap-2">
                        <FaUser className="text-gray-500" />
                        <div className="flex flex-col">
                          <span>{userName}</span>
                          <span className="text-xs text-gray-400">User</span>
                        </div>
                      </div>
                    </td>
                    <td colSpan={3} className="px-10 py-2 text-center">
                      <input
                        type="range"
                        min="0"
                        max="2"
                        step="1"
                        value={userPermissions[userName] || 0}
                        onChange={(e) => handleUserSliderChange(userName, e)}
                        className={`w-[76%] slider-input appearance-none h-4 rounded-lg outline-none cursor-pointer
                          ${
                            userPermissions[userName] === 0
                              ? "accessSlider-input"
                              : "slider-input"
                          }
                        `}
                      />
                    </td>
                  </tr>
                ))}
                {entry.allowedGroups?.map((groupName, i) => (
                  <tr
                    key={`group-${groupName}-${i}`}
                    className="border-b border-gray-200 hover:bg-gray-50 text-sm"
                  >
                    <td className=" px-10 py-2 ">
                      <div className="flex items-center gap-2">
                        <FaUsers className="text-gray-500" />

                        <div className="flex flex-col">
                          <span>{groupName}</span>
                          <span className="text-xs text-gray-400">Group</span>
                        </div>
                      </div>
                    </td>
                    <td colSpan={3} className="px-10 py-2 text-center">
                      <input
                        type="range"
                        min="0"
                        max="2"
                        step="1"
                        value={groupPermissions[groupName] || 0}
                        onChange={(e) => handleGroupSliderChange(groupName, e)}
                        className={`w-[76%] slider-input appearance-none h-4 rounded-lg outline-none cursor-pointer
                          ${
                            groupPermissions[groupName] === 0
                              ? "accessSlider-input"
                              : "slider-input"
                          }
                        `}
                      />
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add user role button */}
      <div className="mt-6">
        <button
          className="bg-blue-900 text-white text-sm px-4 py-2 rounded-md hover:bg-indigo-800"
          onClick={() => setShowModal(true)}
        >
          Add User Roles
        </button>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl w-[400px] p-6 shadow-2xl">
            {/* Header */}
            <div className="flex justify-between items-center mb-5">
              <h2 className="text-lg font-semibold text-gray-800">
                Add User/Group Rule
              </h2>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-400 hover:text-gray-700 text-2xl"
              >
                &times;
              </button>
            </div>

            {/* Search */}
            <input
              type="text"
              placeholder="Search users or groups"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-[95%] border border-gray-300 rounded-lg px-3 py-2 text-sm mb-4 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />

            {/* Select All */}
            <label className="flex items-center text-sm font-medium mb-2 text-gray-700">
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAllChange}
                className="mr-2 accent-indigo-600"
              />
              Select All
            </label>

            {/* List */}
            <div className="h-32 overflow-y-auto border border-gray-200 rounded-lg px-3 py-2 text-sm space-y-2 mb-4">
              {allFilteredItems.map((item) => (
                <label
                  key={item.id}
                  className="flex items-center text-gray-700"
                >
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(item.id)}
                    onChange={() => handleCheckboxChange(item.id)}
                    className="mr-2 accent-indigo-600"
                  />
                  {item.label}
                </label>
              ))}
            </div>
            <select
              value={selectedPermission}
              onChange={(e) => setSelectedPermission(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm mb-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="read">Viewer</option>
              <option value="edit">Editor</option>
              {/* <option value="publish">Publish</option> */}
              <option value="no access">No access</option>
            </select>

            {/* Messages */}
            {isUpdateError && (
              <div className="text-red-600 text-sm mb-2">
                There was an error saving the data. Please try again.
              </div>
            )}
            {isUpdateSuccess && (
              <div className="text-green-600 text-sm mb-2">
                Data saved successfully.
              </div>
            )}
            {isUpdating && (
              <div className="text-indigo-600 text-sm mb-2">
                Saving data... please wait.
              </div>
            )}

            {/* Buttons */}
            <div className="flex justify-end gap-3 mt-4">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 text-sm bg-blue-950 text-white rounded-md hover:bg-blue-900 transition"
              >
                {isUpdating ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Accessworkbookpage;
